import logger from '../../../../core/utils/src/logger';
import { FilteringOperation } from '../internal';
var update = function (items, propertyFilteringData) {
    var filteringFunction = propertyFilteringData.filteringFunction, filteringText = propertyFilteringData.filteringText, operation = propertyFilteringData.operation, tokens = propertyFilteringData.tokens;
    return {
        filteringFunction: filteringFunction,
        filteringText: filteringText,
        items: filteringFunction ? items.filter(function (item) { return filteringFunction(item, tokens, operation); }) : items.slice(),
        operation: operation,
        tokens: tokens
    };
};
var compare = function (oldFilteringData, newFilteringData, userAction) {
    return (userAction &&
        (oldFilteringData.filteringText !== newFilteringData.filteringText ||
            oldFilteringData.operation !== newFilteringData.operation ||
            oldFilteringData.tokens !== newFilteringData.tokens));
};
var getOperationFn = function (operation) {
    switch (operation) {
        case FilteringOperation.OR:
            return function (value1, value2) { return value1 || value2; };
        case FilteringOperation.AND:
        default:
            // This default has been intentionally added as defensive programming to catch
            // unsupported operations passed in my customers of the API
            return function (value1, value2) { return value1 && value2; };
    }
};
var getMatchFn = function (negated, matchStrategy) {
    return negated ? function (a, b) { return !matchStrategy(a, b); } : matchStrategy;
};
var fullMatchStategy = function (token, item) {
    return token.value == item[token.propertyKey];
};
var partialMatchStategy = function (token, item) {
    var searchText = token.value.toLowerCase();
    var searchableProps = token.propertyKey ? [token.propertyKey] : Object.keys(item);
    return searchableProps.some(function (prop) {
        return typeof item[prop] === 'string' && item[prop].toLowerCase().indexOf(searchText) !== -1;
    });
};
var filterOptions = function (options, text) {
    return options.reduce(function (filteredIn, option) {
        var optionGroup = option;
        if (optionGroup.options) {
            var filteredInGroupOptions = filterOptions(optionGroup.options, text);
            if (filteredInGroupOptions.length > 0) {
                filteredIn.push({
                    label: optionGroup.label,
                    disabled: optionGroup.disabled,
                    options: filteredInGroupOptions
                });
            }
        }
        else if (__matchSingleOption(option, text)) {
            filteredIn.push(option);
        }
        return filteredIn;
    }, []);
};
var __matchSingleOption = function (option, text) {
    var searchableFields = ['value', 'label'];
    var searchText = text.toLowerCase();
    return searchableFields.some(function (attr) {
        var value = option[attr];
        if (typeof value !== 'string') {
            logger.warn("Property filtering received an unsupported " + attr + " type: " + typeof value);
        }
        return value && value.toLowerCase().indexOf(searchText) !== -1;
    });
};
var defaultFilteringFunction = function (item, tokens, operation) {
    return (!tokens.length ||
        tokens.reduce(function (include, token) {
            var opFn = getOperationFn(operation);
            var strategy = token.isFreeText ? partialMatchStategy : fullMatchStategy;
            var eqFn = getMatchFn(token.negated, strategy);
            return opFn(include, eqFn(token, item));
        }, operation === FilteringOperation.AND));
};
var getPropertyPrefixFormat = function (property) { return property + ": "; };
export default {
    compare: compare,
    update: update,
    defaultFilteringFunction: defaultFilteringFunction,
    filterOptions: filterOptions,
    getPropertyPrefixFormat: getPropertyPrefixFormat,
    getMatchFn: getMatchFn
};
//# sourceMappingURL=utils.js.map